import type { ReactNode } from "react";
import { Link } from "@fluentui/react-components";
import type { EAppId} from "../../interfaces";
import { configurableApplication } from "../../interfaces";
import { appSettingInfoLink } from "../../utilities/ConfigurationData/ConfigurationData";

export interface IInfoLabelWithLinkProps {
    appId: EAppId;
    showInfoLabel?: boolean;
}

export const InfoLabelWithLink = (props: IInfoLabelWithLinkProps) => {
    const { showInfoLabel, appId } = props;

    const renderInfoLabelWithLink = (): ReactNode => {
        const link = appSettingInfoLink[appId];
        return link ? (
            <div>
                {showInfoLabel && <p>
                    Configure {configurableApplication[appId]} by adding and modifying the available settings.
                </p>}
                <Link onClick={() => window.open(link)}>Configuration settings available in {configurableApplication[appId]}</Link>
            </div>
        ) : null;
    };

    return (renderInfoLabelWithLink());
};